import { render, staticRenderFns } from "./profile-workspace.vue?vue&type=template&id=73020cc2&"
import script from "./profile-workspace.vue?vue&type=script&lang=js&"
export * from "./profile-workspace.vue?vue&type=script&lang=js&"
import style0 from "./profile-workspace.vue?vue&type=style&index=0&id=73020cc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports